import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/** Single app-wide toast host — positioned below mobile navbar / safe area. */
export function AppToastContainer() {
  return (
    <ToastContainer
      position="top-center"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      className="app-toast-container"
      toastClassName="app-toast"
    />
  );
}

export default AppToastContainer;
